'use client';

import type { FC } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import BusinessContactForm, {
    type BusinessContactFormProps,
} from '@/components/organisms/BusinessContactForm';

import { env } from '@/env.mjs';

const BusinessContactFormTemplate: FC<BusinessContactFormProps> = config => (
    <GoogleReCaptchaProvider reCaptchaKey={env.NEXT_PUBLIC_RECAPTCHA_KEY}>
        <BusinessContactForm {...config} />
    </GoogleReCaptchaProvider>
);

export default BusinessContactFormTemplate;
